import React, { useState, useEffect } from "react";
import { Grid, Typography, Divider, Box } from "@material-ui/core";
import { Button } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import MdlSidebarOverlay from "../Sidebar/MdlSidebarOverlay";
import MdlSheetEdit from "./MdlSheetEdit"; 
import axios from "axios";

function SheetInformationCard({ infoText, sheet }) {
  const [modal, setModal] = useState(false);
  const [liveSheet, setLiveSheet] = useState(sheet || {});

  useEffect(() => {
    if (sheet && sheet.safeSheetName) {
      axios.get(`/sheet/${sheet.safeSheetName}`)
        .then(res => {
          if (res.data) setLiveSheet(res.data);
        })
        .catch(() => setLiveSheet(sheet));
    } else {
      setLiveSheet(sheet || {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps	
  }, [sheet?.safeSheetName, modal]);

  // ⭐ FIX 1: Absolut sichere URL-Generierung außerhalb des JSX-Baums blockiert jeden Maskierungsfehler!
  const currentMbid = liveSheet.mbid || liveSheet.mbId || "";
  const musicBrainzUrl = currentMbid ? "https://musicbrainz.org/recording/" + currentMbid : "#";
  const currentTrackViewUrl = liveSheet.trackViewUrl || "";

  return (
    <div className="doc_box tags_overview_box" style={{ marginTop: "0px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span className="sheet_info_header">Information & Details</span>
		<Button
		  variant="contained"
		  size="small"
		  startIcon={<EditIcon />}
		  onClick={() => setModal(true)}
		  style={{ backgroundColor: "#4f40b3", color: "white", textTransform: "none", borderRadius: "8px" }}
		>Bearbeiten
		</Button>
        <MdlSidebarOverlay title="Edit Info Box & Music Details" onClose={() => setModal(false)} show={modal}>
          <MdlSheetEdit onClose={() => setModal(false)} sheet={liveSheet} />
        </MdlSidebarOverlay>
      </div>

      
      {liveSheet && (
        <Grid container spacing={2} style={{ padding: "10px 0", marginBottom: "10px" }}>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>Tonart</Typography>
            <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>
              {liveSheet.key_signature || liveSheet.KeySignature || liveSheet.keySignature || "-"}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>Tempo</Typography>
            <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>
              {liveSheet.tempo || liveSheet.Tempo ? `${liveSheet.tempo || liveSheet.Tempo} BPM` : "-"}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>Dauer</Typography>
            <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>
              {liveSheet.duration || liveSheet.Duration || "-"}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>Instrument</Typography>
            <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>
              {liveSheet.instrument || liveSheet.Instrument || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} style={{ marginTop: "4px" }}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>Album / Kollektion</Typography>
            <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>
              {liveSheet.collection || liveSheet.Collection || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} style={{ marginTop: "4px" }}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>YouTube Video</Typography>
            <Box style={{ marginTop: "4px" }}>
              {liveSheet.youtube_link || liveSheet.YoutubeLink || liveSheet.youtubeLink ? (
                <a 
                  href={liveSheet.youtube_link || liveSheet.YoutubeLink || liveSheet.youtubeLink} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ color: "#4f40b3", textDecoration: "underline", fontSize: "14px", fontWeight: 500 }}
                >
                  Video auf YouTube ansehen
                </a>
              ) : (
                <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>-</Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={6} style={{ marginTop: "6px" }}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>MusicBrainz Identifikator</Typography>
            <Box style={{ marginTop: "4px" }}>
              {currentMbid ? (
                <a
                  href={musicBrainzUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#f4f3f9",
                    color: "#4f40b3",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontFamily: "monospace",
                    textDecoration: "none",
                    fontWeight: 600,
                    border: "1px solid rgba(79, 64, 179, 0.15)"
                  }}
                >
                  🆔 {currentMbid.substring(0, 8)}... (In Enzyklopädie öffnen)
                </a>
              ) : (
                <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>-</Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} style={{ marginTop: "6px" }}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>iTunes Link</Typography>
            <Box style={{ marginTop: "4px" }}>
              {currentTrackViewUrl ? (
                <a
                  href={currentTrackViewUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#f4f3f9",
                    color: "#4f40b3",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontFamily: "monospace",
                    textDecoration: "none",
                    fontWeight: 600,
                    border: "1px solid rgba(79, 64, 179, 0.15)"
                  }}
                >
                  🍎 {currentTrackViewUrl.toString().substring(0, 8)}... (In Apple Music öffnen)
                </a>
              ) : (
                <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>-</Typography>
              )}
            </Box>
          </Grid>
		  
		  <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>Genre / Musikstil</Typography>
            <Typography variant="body2" style={{ fontWeight: 600, color: "#1d1b31" }}>
              {liveSheet.category || liveSheet.Category || "-"}
            </Typography>
          </Grid>
		  
        </Grid>
      )}

      <Divider style={{ margin: "10px 0" }} />

      <div className="info_text" style={{ marginTop: "10px" }}>
        <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: "4px" }}>Beschreibung</Typography>
        <span style={{ color: "#464646", fontSize: "14px", fontFamily: "Open Sans" }}>
          {liveSheet.information_text || liveSheet.InformationText || infoText || "Keine Beschreibung vorhanden."}
        </span>
      </div>
    </div>
  );
}

export default SheetInformationCard;
